import {
  RESET_RULE_FILTERS,
  UPDATE_ACTIVE_FILTERS,
  UPDATE_COUNTRIES_FILTER,
  UPDATE_DATE_OPERATOR,
  UPDATE_DIRECT_REPORTS,
  UPDATE_EMPLOYEE_JOB_LEVEL,
  UPDATE_HIRE_END_DATE,
  UPDATE_HIRE_START_DATE,
  UPDATE_LEADER_LEVEL,
  UPDATE_LEADER_LOGINS,
  UPDATE_MANAGER,
  UPDATE_METRIC_FILTER,
  UPDATE_METRIC_NAME,
  UPDATE_METRIC_OPERATOR,
  UPDATE_METRIC_VALUE,
  UPDATE_RULE_FILTERS,
} from './ruleFiltersActionTypes';

export const updateRuleFilters = ruleFilters => ({
  type: UPDATE_RULE_FILTERS,
  payload: ruleFilters,
});

export const updateLeaderLevel = leaderLevel => dispatch => {
  dispatch({
    type: UPDATE_LEADER_LEVEL,
    payload: leaderLevel,
  });
};

export const updateLeaderLogins = leaderLogins => dispatch => {
  dispatch({
    type: UPDATE_LEADER_LOGINS,
    payload: leaderLogins,
  });
};

export const updateCountries = countries => dispatch => {
  dispatch({
    type: UPDATE_COUNTRIES_FILTER,
    payload: countries,
  });
};

export const updateManagerFilter = isManager => dispatch => {
  dispatch({
    type: UPDATE_MANAGER,
    payload: isManager,
  });
};

export const updateEmployeeJobLevel = jobLevels => dispatch => {
  dispatch({
    type: UPDATE_EMPLOYEE_JOB_LEVEL,
    payload: jobLevels,
  });
};

export const updateActiveFilters = activeFilters => dispatch => {
  dispatch({
    type: UPDATE_ACTIVE_FILTERS,
    payload: activeFilters,
  });
};

export const updateDateOperator = dateOperator => dispatch => {
  dispatch({
    type: UPDATE_DATE_OPERATOR,
    payload: dateOperator,
  });
};

export const updateHireStartDate = hireDate => dispatch => {
  dispatch({
    type: UPDATE_HIRE_START_DATE,
    payload: hireDate,
  });
};

export const updateHireEndDate = hireEndDate => dispatch => {
  dispatch({
    type: UPDATE_HIRE_END_DATE,
    payload: hireEndDate,
  });
};

export const updateMetricOperator = metricOperator => dispatch => {
  dispatch({
    type: UPDATE_METRIC_OPERATOR,
    payload: metricOperator,
  });
};

export const updateMetricName = metricName => dispatch => {
  dispatch({
    type: UPDATE_METRIC_NAME,
    payload: metricName,
  });
};

export const updateMetricValue = metricValue => dispatch => {
  dispatch({
    type: UPDATE_METRIC_VALUE,
    payload: metricValue,
  });
};

export const updateDirectReportsFilter = value => dispatch => {
  dispatch({
    type: UPDATE_DIRECT_REPORTS,
    payload: value,
  });
};

export const updateMetricFilter = metricList => dispatch => {
  dispatch({
    type: UPDATE_METRIC_FILTER,
    payload: metricList,
  });
};

export const resetRuleFilters = () => ({
  type: RESET_RULE_FILTERS,
});
